/*
 * Copyright (c) 2018-present, Revolut LTD.
 *
 * This source code is licensed under the Apache 2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

export const PURPLE = '#172a40'
export const DEEP_BLUE = '#0075eb'
export const BLUE = '#0075eb'
export const BRICK_RED = '#d9383a'
export const RED = '#d91e00'
export const GREEN = '#8ad937'
export const BLACK = '#000000'
export const DARK_GREY = '#191c1e'
export const LIGHT_GREY = '#8b959e'
export const LIGHTER_GREY = '#ced5dc'
export const SOFT_GREY = '#eee'
export const MEDIUM_GRAY = '#a0a6ad'
export const WHITE = '#ffffff'
export const DARK_CYAN = '#09504F'
export const ROSE = '#eb008d'
export const LIGHT_CYAN = '#a7c7c5'
export const BUTTON_BLUE = 'rgb(22, 116, 210)'

export const BUTTON_SHADOW = '0px 2px 4px rgba(0, 0, 0, 0.5);'

export const BUTTON_GROUP_SHADOW =
  '0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);'
